import { useQuery } from "@tanstack/react-query";
import { fetchReportingLessonsStatus } from "@/api/metadata";
import type { ReportingLessonsStatus } from "../models/reportingLessonsStatus";

export const REPORTING_LESSONS_STATUS_QUERY_KEY = [
  "cle-compliance",
  "status",
  "reporting-lessons",
] as const;

type UseReportingLessonsStatusParams = {
  periodStart?: string;
  periodEnd?: string;
};

export const useReportingLessonsStatus = ({
  periodStart,
  periodEnd,
}: UseReportingLessonsStatusParams) => {
  return useQuery<ReportingLessonsStatus>({
    queryKey: [...REPORTING_LESSONS_STATUS_QUERY_KEY, periodStart, periodEnd],
    queryFn: () => fetchReportingLessonsStatus(periodStart!, periodEnd!),
    enabled: Boolean(periodStart && periodEnd),
    staleTime: 5 * 60 * 1000,
  });
};
